// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export const API_ENDPOINTS = {
  LOGIN: '/v1/admin/auth/login',
  PROMPTS: '/v1/admin/prompts',
  PROMPT: (name) => `/v1/admin/prompts/${name}`,
};
